var _style, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLayers = function SvgLayers(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svgLayers",
    x: "0px",
    y: "0px",
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    style: {
      enableBackground: "new 0 0 18 18"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.svgLayers{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svgLayers_g",
    transform: "translate(-.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_868",
    className: "svgLayers svgBase svgHover svgSelect",
    d: "M9,13.9c-0.2,0-0.4,0-0.6-0.1L1,9.9C0.7,9.6,0.6,9.3,0.8,9c0.1-0.2,0.4-0.4,0.6-0.3 c0,0,0.1,0,0.1,0.1l7.5,4l7.5-4c0.3-0.1,0.5,0,0.7,0.2c0.1,0.3,0,0.6-0.2,0.8l-7.5,4C9.4,13.9,9.2,13.9,9,13.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_869",
    className: "svgLayers svgBase svgHover svgSelect",
    d: "M9,10.5c-0.2,0-0.3,0-0.5-0.1L1.5,6.6C1.1,6.4,0.9,6.1,0.9,5.7c0-0.4,0.2-0.8,0.6-0.9l7.1-3.8 c0.3-0.2,0.6-0.2,0.9,0l7.1,3.8c0.3,0.2,0.6,0.6,0.6,0.9c0,0.4-0.2,0.8-0.6,0.9l-7.1,3.8C9.3,10.5,9.2,10.5,9,10.5z M9,9.5l7.1-3.8 V5.6L9,1.8L1.9,5.6v0.1L9,9.5z M9,17.2c-0.2,0-0.4,0-0.6-0.1l-7.5-4c-0.3-0.1-0.4-0.4-0.2-0.7c0,0,0-0.1,0.1-0.1 c0.1-0.2,0.4-0.4,0.6-0.3c0,0,0.1,0,0.1,0.1l7.5,4l7.5-4c0.3-0.1,0.5,0,0.7,0.2c0.1,0.3,0,0.6-0.2,0.8l-7.5,4 C9.4,17.2,9.2,17.2,9,17.2z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLayers, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/layers.c5d4eab3.svg";
export { ForwardRef as ReactComponent };